import {defineStore} from "pinia";
export const ingresoStore = defineStore("ingresoStore", {
    state: () =>
        ({
            loading: false as boolean,
            esEditar: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            nuevoCodigo: '',
            ingreso: [],
            factura: '',
            ingresoMaterial: [] as any[],
            funcionario_responsable: [],
            funcionario_responsable_autoriza: [],
            tipo: [],
            empresa: [],
            historial: [] as any[],
            showDialogSancion: false as boolean,
        }),
});